export default {
  user(state) {
    return state.user;
  },
  getSellerId(state) {
    return state.user.sellerId;
  },
  getUserInfos(state) {
    return state.user;
  },
  isLoggedIn(state) {
    return state.isLoggedIn;
  },
  isAnonymous(state) {
    return state.isAnonymous;
  },
  isPending(state) {
    return state.isPending;
  },
  isPersistingUser(state) {
    return state.isPersistingUserPending;
  },
  getErrorMessage(state) {
    return state.errorMessage;
  },
  getPersistUserError(state) {
    return state.errorOfPersistUser;
  },
  getAuthStatus(state) {
    return {
      isLoggedIn: state.isLoggedIn,
      isAnonymous: state.isAnonymous,
      isPending: state.isPending,
    };
  },
};
